import { render, staticRenderFns } from "./about.vue?vue&type=template&id=c4c52e7e&scoped=true&"
import script from "./about.vue?vue&type=script&lang=js&"
export * from "./about.vue?vue&type=script&lang=js&"
import style0 from "./about.vue?vue&type=style&index=0&id=c4c52e7e&lang=scss&scoped=true&"
import style1 from "./about.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c52e7e",
  null
  
)

export default component.exports